'use strict';

var React = require('react'),
    Modal = require('react-bootstrap-modal'),
    connect = require('react-redux').connect;

var LoadingModal = React.createClass({
	displayName: 'LoadingModal',

	propTypes: {
		show: React.PropTypes.bool.isRequired
	},

	render: function render() {
		return React.createElement(
			Modal,
			{ show: this.props.show, backdrop: 'static' },
			React.createElement(
				Modal.Body,
				null,
				'Loading...'
			)
		);
	}
});

module.exports = connect(function mapStateToProps(state) {
	return {
		show: state.dialogs.isLoadingModalShowing
	};
})(LoadingModal);


//////////////////
// WEBPACK FOOTER
// ./client/components/LoadingModal.js
// module id = 172
// module chunks = 5